import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { F, inputCls, btnPrimary } from "@/components/admin/ui";

const FIELDS = [["name", "Nama penerbit", "sm:col-span-3"], ["division", "Divisi", "sm:col-span-3"], ["address", "Alamat", "sm:col-span-6"], ["phone", "Telepon", "sm:col-span-3"], ["email", "Email", "sm:col-span-3"]];

export function IssuerSettings() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/admin/issuer").then((r) => setF(r.data)); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/admin/issuer", f); setF(data); toast.success("Data penerbit invoice disimpan"); } catch (ex) { toast.error(errMsg(ex)); }
  };
  return (
    <div className="soft-card p-5" data-testid="issuer-settings">
      <button type="button" data-testid="issuer-toggle" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between text-left">
        <div><p className="text-sm font-semibold">Data penerbit invoice</p><p className="text-xs text-muted-foreground">{f?.name || "…"}{f?.bank ? " · rekening tersimpan" : " · rekening belum diisi"}</p></div>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && f && (
        <form onSubmit={save} className="mt-4 grid gap-3 sm:grid-cols-6">
          {FIELDS.map(([k, l, c]) => <F key={k} label={l} className={c}><input data-testid={`issuer-${k}-input`} className={inputCls} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} /></F>)}
          <F label="Rekening bank (bisa beberapa baris)" className="sm:col-span-3"><textarea data-testid="issuer-bank-input" rows={4} className={inputCls} value={f.bank || ""} onChange={(e) => setF({ ...f, bank: e.target.value })} placeholder={"Bank: …\nCabang: …\nNo. Rek: …\nAtas nama: …"} /></F>
          <F label="Catatan di invoice" className="sm:col-span-3"><textarea data-testid="issuer-note-input" rows={4} className={inputCls} value={f.note || ""} onChange={(e) => setF({ ...f, note: e.target.value })} /></F>
          <div className="sm:col-span-6"><button data-testid="issuer-save-button" className={btnPrimary}>Simpan penerbit</button></div>
        </form>
      )}
    </div>
  );
}
